import Axios from "axios";
import toast from "react-hot-toast";
import { Navigate } from "react-router-dom";
import {message} from "../../components/messages/Message"

const axiosInstance = Axios.create({
  withCredentials: true, 
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
});

axiosInstance.interceptors.request.use((config) => {
  const token = document.cookie
    .split('; ')
    .find(row => row.startsWith('XSRF-TOKEN='))
    ?.split('=')[1];

  if (token) {
    config.headers['X-XSRF-TOKEN'] = decodeURIComponent(token);
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url;

    if (status === 401) {
      if (requestUrl && requestUrl.includes("/login")) {
        return Promise.reject(error);
      }

      toast.error(message.LogoutMessage);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("permissions");
      localStorage.removeItem("urlLink");
      window.location.replace("/login");
    }

    return Promise.reject(error);
  }
);



export const apiConnector = (method, url, bodyData, headers, params) => {
  return axiosInstance({
    method: method,
    url: url,
    data: bodyData || null,
    headers: headers ? { ...axiosInstance.defaults.headers, ...headers } : axiosInstance.defaults.headers,
    params: params || null,
  });
};
